import React from 'react';

const LoadingSpinner: React.FC = () => {
    return (
        <div className="text-center py-12">
            <div className="inline-block">
                <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
                <p className="text-gray-600 font-medium">Loading...</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;